function getBaseUrl () {
  const host = document.location.host
  const protocol = document.location.protocol
  const pathname = document.location.pathname

  // Detectar la URL base del proyecto (funciona en raíz o subdirectorio)
  const getBaseUrl = () => {
    // Obtener la URL completa actual
    const currentUrl = window.location.href

    // Obtener la ruta del script actual
    const scriptPath = document.currentScript?.src ||
      document.querySelector('script[src*="global.js"]')?.src ||
      currentUrl

    // Determinar la base URL a partir de la ubicación del script
    let baseUrl = ''

    if (scriptPath.includes('/js/global.js')) {
      // Extraer la base URL eliminando '/js/global.js' del final
      baseUrl = scriptPath.substring(0, scriptPath.indexOf('/js/global.js'))
    } else {
      // Fallback: usar el dominio actual
      baseUrl = protocol + '//' + host

      // Si estamos en un subdirectorio conocido del proyecto, ajustar la URL base
      const possibleProjectPaths = ['/FDG', '/fdg', '/proyectos/FDG', '/proyectos/fdg']

      for (const projectPath of possibleProjectPaths) {
        if (pathname.includes(projectPath)) {
          const pathIndex = pathname.indexOf(projectPath)
          const basePath = pathname.substring(0, pathIndex + projectPath.length)
          baseUrl += basePath
          break
        }
      }
    }

    // Eliminar cualquier barra diagonal al final
    return baseUrl.replace(/\/+$/, '')
  }

  return getBaseUrl()
}

export default getBaseUrl
